import { GetVendaController } from "../../../Controllers/Geral/InformacoesVenda/InformacoesVendaControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import OrSpinner from "../../Utils/OrSpinner";
import EditarStatusEscritura from "../ProdutosCobranca/InformacoesVenda/InfoEscritura/EditarStatusEscritura";

interface IAtualizarStatusEscrituraVendaDoCasoProps {
    ID_CHAVE_ERP: string;
    setShow(show: boolean): void;
}

export default function AtualizarStatusEscrituraVendaDoCaso(
    props: IAtualizarStatusEscrituraVendaDoCasoProps
) {
    const { value: venda, loading } = useAsyncEffect(() => {
        return GetVendaController(props.ID_CHAVE_ERP);
    }, [props.ID_CHAVE_ERP]);

    return (
        <OrSpinner loading={loading && !venda} spinner="erp">
            {venda ? (
                <EditarStatusEscritura
                    lstIdsEscritura={venda.LstEscrituras}
                    then={() => props.setShow(false)}
                />
            ) : (
                <div className="text-muted text-center">
                    Erro ao carregar dados do ERP
                </div>
            )}
        </OrSpinner>
    );
}
